import React from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "@/components/shared/PublicHeader";
import MemberSidebar from "@/components/layout/MemberSidebar";
import Footer from "@/components/Footer";

export default function MemberShell() {
    return (
        <div className="flex flex-col min-h-screen">
            <PublicHeader />
            <main className="flex-1 pt-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-24 md:pb-8">
                    <div className="flex gap-8 items-start">
                        <MemberSidebar />
                        <div className="flex-1 min-w-0">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
